import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { useTranslate } from '@tolgee/react';
import { BarChart } from '~/components/charts/BarChart';

interface Props {
  readonly priceHubbleStatistics: {
    readonly meanSalePricePerSquareMeter: number;
    readonly medianLowSalePricePerSquareMeter: number;
    readonly medianHighSalePricePerSquareMeter: number;
  };
}

export function MarketEvolutionBarWidget(props: Props) {
  const { t } = useTranslate();

  if (
    props.priceHubbleStatistics?.meanSalePricePerSquareMeter == null ||
    props.priceHubbleStatistics?.medianLowSalePricePerSquareMeter == null ||
    props.priceHubbleStatistics?.medianHighSalePricePerSquareMeter == null
  ) {
    return (
      <WrapperWidget>
        <EmptyState
          title={t('market_evolution_bar_widget_title')}
          description={t('empty_no_data_available')}
        />
      </WrapperWidget>
    );
  }

  const chartData = [
    {
      x: t('market_evolution_bar_widget_bar_text_median_low'),
      y: props.priceHubbleStatistics?.medianLowSalePricePerSquareMeter,
    },
    {
      x: t('market_evolution_bar_widget_bar_text_median_high'),
      y: props.priceHubbleStatistics?.medianHighSalePricePerSquareMeter,
    },
  ];

  const annotations = {
    meanLine: {
      yMin: props.priceHubbleStatistics?.meanSalePricePerSquareMeter,
      yMax: props.priceHubbleStatistics?.meanSalePricePerSquareMeter,
      borderColor: 'gray',
      borderWidth: 2,
      borderDash: [
        10,
        5,
      ],
      label: {
        content: t('market_evolution_bar_widget_bar_text_middle', {
          meanSalePricePerSquareMeter:
            props.priceHubbleStatistics?.meanSalePricePerSquareMeter?.toFixed(
              2,
            ),
        }),
        display: true,
        position: 'center',
        backgroundColor:
          typeof document !== 'undefined' &&
          document.documentElement.classList.contains('dark')
            ? 'rgba(31, 41, 55, 0.9)'
            : 'rgba(255, 255, 255, 0.7)',
        color:
          typeof document !== 'undefined' &&
          document.documentElement.classList.contains('dark')
            ? '#d1d5db'
            : 'black',
      },
    },
  };

  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          {t('market_evolution_bar_widget_title')}
        </h2>

        <p className="whitespace-pre-wrap">
          {t('market_evolution_bar_widget_text')}
        </p>
        <BarChart
          datasetIdKey="market-evolution-bar-chart"
          data={chartData}
          annotations={annotations}
          displayDatalabels={true}
          yFormat="currency"
        />
      </div>
    </WrapperWidget>
  );
}
